import { myFetch, HttpMethod } from './baseService';

// Interfaz para la solicitud de obtener libro de visitas
export interface GetLibroVisitasRequest {
  "unidad residencial codigo": string;
  "codigo": string;
  "nombre visitante": string;
}

// Interfaz para un registro del libro de visitas
export interface LibroVisita {
  lvi_codigo: number;
  lvi_unidad_residencial: string;
  lvi_unidad_residencial_nombre: string;
  lvi_fecha_ingreso: string;
  lvi_fecha_salida: string;
  lvi_nombre_completo: string;
  lvi_ruta_foto: string;
  lvi_tipo_documento: string;
  lvi_tipo_documento_nombre: string;
  lvi_numero_documento: string;
  lvi_celular: string;
  lvi_torre_nombre: string;
  lvi_apartamento_nombre: string;
  lvi_motivo_visita: string;
  lvi_vehiculo: string;
  lvi_vehiculo_placa: string;
}

// Interfaz genérica para la respuesta
export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

// Interfaz para la solicitud de insertar visitante
export interface InsertarVisitanteRequest {
  "unidad residencial codigo": string;
  "nombre visitante": string;
  "tipo documento codigo"?: string;
  "nuemro documento"?: string;
  "numero celular": string;
  "torre": string;
  "apartamento": string;
  "motivo visita": string;
  "tipo vehiculo"?: string;
  "placa vehiculo"?: string;
  "foto_base64"?: string;
}

// Función para obtener todos los registros del libro de visitas
export const getLibroVisitas = async (payload: GetLibroVisitasRequest) => {
  const envelope = await myFetch<ApiEnvelope<any[]>>(
    'libro_visitas/ObtenerTodos',
    HttpMethod.POST,
    payload
  );

  if (!envelope.object_) {
    throw new Error('Respuesta inesperada del servidor');
  }

  // Normalizamos los nombres de campos que vienen del backend (vis_*) a la interfaz usada en el front (lvi_*)
  const normalized: LibroVisita[] = (envelope.object_ as any[]).map((item) => ({
    lvi_codigo: item.lvi_codigo ?? item.vis_codigo,
    lvi_unidad_residencial: item.lvi_unidad_residencial ?? item.vis_unidad_residencial ?? '',
    lvi_unidad_residencial_nombre: item.lvi_unidad_residencial_nombre ?? item.vis_unidad_residencial_nombre ?? '',
    lvi_fecha_ingreso: item.lvi_fecha_ingreso ?? item.vis_fecha_ingreso ?? '',
    lvi_fecha_salida: item.lvi_fecha_salida ?? item.vis_fecha_salida ?? '',
    lvi_nombre_completo: item.lvi_nombre_completo ?? item.vis_nombre_completo ?? '',
    lvi_ruta_foto: item.lvi_ruta_foto ?? item.vis_ruta_foto ?? '',
    lvi_tipo_documento: item.lvi_tipo_documento ?? item.vis_tipo_documento ?? '',
    lvi_tipo_documento_nombre: item.lvi_tipo_documento_nombre ?? item.vis_tipo_documento_nombre ?? '',
    lvi_numero_documento: item.lvi_numero_documento ?? item.vis_numero_documento ?? '',
    lvi_celular: item.lvi_celular ?? item.vis_celular ?? '',
    lvi_torre_nombre: item.lvi_torre_nombre ?? item.vis_torre_nombre ?? '',
    lvi_apartamento_nombre: item.lvi_apartamento_nombre ?? item.vis_apartamento_nombre ?? '',
    lvi_motivo_visita: item.lvi_motivo_visita ?? item.vis_motivo_visita ?? '',
    lvi_vehiculo: item.lvi_vehiculo ?? item.vis_vehiculo ?? '',
    lvi_vehiculo_placa: item.lvi_vehiculo_placa ?? item.vis_vehiculo_placa ?? '',
  }));

  return normalized;
};

// Función para insertar un nuevo visitante
export const insertarVisitante = async (payload: InsertarVisitanteRequest) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    'libro_visitas/Insertar',
    HttpMethod.POST,
    payload
  );

  return envelope;
};

